import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";

const ExamsHome = loadable(() => import("./ExamsHome"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ExamsHome {...props} />
  </ErrorBoundary>
);

export { ExamsHome as PreFetchExamsHome };
